"use client";

import { c as _c } from "react/compiler-runtime";
import { Minus, Plus } from "lucide-react";
import { useState } from "react";
type ParticipantSelectorProps = {
  min?: number;
  onChange?: (value: number) => void;
  noLabel?: boolean;
  disabled?: boolean;
  initial?: number;
};
export const ParticipantSelector = t0 => {
  const $ = _c(28);
  const {
    min,
    onChange,
    noLabel,
    disabled,
    initial
  } = t0;
  const minCount = min ?? 1;
  const [count, setCount] = useState(initial || minCount);
  let t1;
  if ($[0] !== onChange) {
    t1 = value => {
      setCount(value);
      onChange?.(value);
    };
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const updateCount = t1;
  let t2;
  if ($[2] !== noLabel) {
    t2 = !noLabel && <span className="text-sm font-semibold text-slate-600 dark:text-slate-400">Learners:</span>;
    $[2] = noLabel;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== count || $[5] !== minCount || $[6] !== updateCount) {
    t3 = () => updateCount(count > minCount ? count - 1 : count);
    $[4] = count;
    $[5] = minCount;
    $[6] = updateCount;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = disabled || count <= 1;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Minus className="size-3 text-slate-600 dark:text-slate-400" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4) {
    t6 = <button type="button" onClick={t3} disabled={t4} className="dark:active:bg-slate-850 flex h-full items-center justify-center border-r border-slate-200 px-3 transition-colors hover:bg-slate-50 active:bg-slate-100 disabled:pointer-events-none disabled:opacity-30 dark:border-slate-800 dark:hover:bg-slate-900" aria-label="Decrease learners count">{t5}</button>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== count) {
    t7 = <span className="w-10 text-center text-sm font-semibold text-slate-900 select-none dark:text-slate-100">{count}</span>;
    $[12] = count;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== count || $[15] !== updateCount) {
    t8 = () => updateCount(count + 1);
    $[14] = count;
    $[15] = updateCount;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Plus className="size-3 text-slate-600 dark:text-slate-400" />;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== disabled || $[19] !== t8) {
    t10 = <button type="button" onClick={t8} disabled={disabled} className="dark:active:bg-slate-850 flex h-full items-center justify-center border-l border-slate-200 px-3 transition-colors hover:bg-slate-50 active:bg-slate-100 disabled:pointer-events-none disabled:opacity-30 dark:border-slate-800 dark:hover:bg-slate-900" aria-label="Increase learners count">{t9}</button>;
    $[18] = disabled;
    $[19] = t8;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t6 || $[23] !== t7) {
    t11 = <div className="flex h-9 items-center overflow-hidden rounded-lg border border-slate-200 bg-background shadow-sm dark:border-slate-800">{t6}{t7}{t10}</div>;
    $[21] = t10;
    $[22] = t6;
    $[23] = t7;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t2) {
    t12 = <div className="flex w-max items-center justify-end gap-3">{t2}{t11}</div>;
    $[25] = t11;
    $[26] = t2;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  return t12;
};